import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

const formatPhoneNumber = (rawPhoneNumber: string): string => {
  try {
    const number = phoneUtil.parseAndKeepRawInput(rawPhoneNumber);

    // dont event try to format if the phoneNumber is invalid
    if (!phoneUtil.isValidNumber(number)) {
      return rawPhoneNumber;
    }

    return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
  } catch {
    return rawPhoneNumber;
  }
};

export { formatPhoneNumber };
